import {
  CREATE_ENTERPRISE,
  CREATE_ENTERPRISE_SUCCESS,
  CREATE_ENTERPRISE_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const createEnterpriseReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_ENTERPRISE:
      return { ...state, loading: true };
    case CREATE_ENTERPRISE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case CREATE_ENTERPRISE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default createEnterpriseReducer;
